import { useState } from "react";
import { motion } from "framer-motion";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import ServicesSection from "@/components/ServicesSection";
import FleetSection from "@/components/FleetSection";
import SafetyTechSection from "@/components/SafetyTechSection";
import PricingSection from "@/components/PricingSection";
// import TestimonialsSection from "@/components/TestimonialsSection"; // Hidden for now
import AppDownloadSection from "@/components/AppDownloadSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import BookingModal from "@/components/BookingModal";
import WaitlistModal from "@/components/WaitlistModal";
import PilotOverlay from "@/components/PilotOverlay";

const HomePage = () => {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [bookingRideType, setBookingRideType] = useState(null); // null = user chooses, "airport" or "city" = locked
  const [isWaitlistOpen, setIsWaitlistOpen] = useState(false);

  const handleBookNow = (rideType = null) => {
    setBookingRideType(rideType);
    setIsBookingOpen(true);
  };

  // Top-level CTAs (header / hero) → skip ride-type picker, go straight to airport.
  // City rides aren't accepting bookings during beta — those CTAs open the waitlist.
  const handleBookAirport = () => handleBookNow("airport");
  const handleJoinWaitlist = () => setIsWaitlistOpen(true);

  return (
    <div className="min-h-screen bg-sarathi-background">
      <Header onBookNow={handleBookAirport} />
      <main>
        <HeroSection onBookNow={handleBookAirport} />
        <HowItWorksSection />
        <ServicesSection
          onBookAirport={handleBookAirport}
          onJoinWaitlist={handleJoinWaitlist}
        />
        <div className="py-8 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-sarathi-primary/8 to-transparent" />
          <div className="max-w-5xl mx-auto px-6 flex items-center justify-center gap-4">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-sarathi-primary/30 hidden sm:block" />
            <div className="flex flex-col sm:flex-row items-center gap-1.5 sm:gap-3 shrink-0 text-center">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-sarathi-primary hidden sm:block" />
                <span className="text-white font-outfit text-base sm:text-lg font-semibold tracking-wide">Simple, Honest Fares</span>
              </div>
              <span className="text-sarathi-text-secondary text-sm sm:text-base">No hidden charges. No surge pricing.</span>
            </div>
            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-sarathi-primary/30 hidden sm:block" />
          </div>
        </div>
        <FleetSection />
        <SafetyTechSection />
        {/* <TestimonialsSection /> */}
        <AppDownloadSection />
      </main>
      <Footer />
      <WhatsAppButton />
      <BookingModal
        isOpen={isBookingOpen}
        onClose={() => setIsBookingOpen(false)}
        initialRideType={bookingRideType}
        onCityRideRequested={() => {
          setIsBookingOpen(false);
          setIsWaitlistOpen(true);
        }}
      />
      <WaitlistModal
        isOpen={isWaitlistOpen}
        onClose={() => setIsWaitlistOpen(false)}
      />
      <PilotOverlay />
    </div>
  );
};

export default HomePage;
